import { configureStore } from "@reduxjs/toolkit";

import singleDatasetReducer from "./SingleDataset/reducer";
import datasetsReducer from "./Datasets/reducer";
import imageReducer from "./SingleImage/reducer";
import modalsReducer from "./Modals/reducer";
import metaDataReducer from "./Metadata/reducer";
import createDatasetReducer from "./CreateDataset/reducer";

import userReducer from "./User/reducer";

export const rootReducer = {
  datasets: datasetsReducer,
  singleDataset: singleDatasetReducer,
  singleImage: imageReducer,
  modals: modalsReducer,
  metadata: metaDataReducer,
  user: userReducer,
  createDataset: createDatasetReducer,
};

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: {},
});

export type State = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
